module.exports = __webpack_public_path__ + "static/media/light_fixture_suspended_led.d7a3eda1.png";